import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    html {
        font-size: 100%
    }

    body {
        margin: 0;
        padding: 0;
        font-family: sans-serif;
        background-color: #e8f2fc;
    }

    .hosting-element {
        z-index: 99999999;
        position: relative;
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        background-color: white;
    }

    #md-iframe-container {
        position: relative;
        top: 50px;
        margin: 0 auto;
        visibility: hidden;
    }
    
    #md-iframe-container.tablet,
    #md-iframe-container.mobile {
        visibility: visible;
    }
    
    #md-iframe-container.mobile {
        width: 420px;
        height: 888px;
    }
    
    #md-iframe-container.tablet {
        width: 600px;
        height: 853px;
    }

    #md-iframe-container > iframe,
    #md-iframe-container > img {
        position: absolute;
        inset: 0;
        margin: auto;
        display: block;
    }
    
    #md-iframe-container > iframe {
        overflow: hidden;
        background-color: #000;
        border: none;
        z-index: 999;
    }

    #md-iframe-container > img {
        z-index: 1;
        width: 100%;
        height: 100%;
        pointer-events: none;
        object-fit: contain;
    }
    
    #md-iframe-container.tablet > img,
    #md-iframe-container.tablet > iframe {
        aspect-ratio: 37 / 52;
    }
    
    #md-iframe-container.mobile > img,
    #md-iframe-container.mobile > iframe {
        aspect-ratio: 19 / 39;
    }
    
    #md-iframe-container.tablet > iframe {
        inset: 7.5% 6% 5.5%;
        height: calc(100% - 13%);
    }
    
    #md-iframe-container.mobile > iframe {
        inset: 11% 9% 10%;
        height: calc(100% - 21%);
    }

    #md-iframe-container.mobile > img {
        padding-left: 1px;
    }
`;

export default GlobalStyle;